/* YOUY – textura da cor nos seletores do app Glo (out/2026)
   O Glo está configurado para usar a imagem da variante na amostra. Este script troca
   essa foto do óculos inteiro por um recorte ampliado da armação (a textura/cor real),
   preferindo a foto "-04-detalhe" da mesma cor quando existe. Armações bicolores viram
   amostra dividida na diagonal. Resultado fica em cache no navegador. */
(function () {
  if (window.__youyTexturas) return;
  window.__youyTexturas = true;

  var VERSION = 'v10';
  var SEL = '.swatch--gl label.swatch-anchor, .swatches-globo label.swatch-anchor';
  var W = 800, OUT = 48;
  var mem = {};
  var pending = {};

  function store(k, v) { try { localStorage.setItem('ytex:' + VERSION + ':' + k, v); } catch (e) {} }
  function load(k) { try { return localStorage.getItem('ytex:' + VERSION + ':' + k); } catch (e) { return null; } }

  function srcOf(label) {
    var s = label.getAttribute('style') || '';
    var m = s.match(/url\(["']?((?:https?:)?\/\/[^"')]+)/);
    return m ? m[1] : null;
  }
  function keyOf(url) { return url.split('?')[0].split('/').pop(); }
  function sized(url) {
    var u = url.replace(/([?&])(width|height)=\d+&?/g, '$1').replace(/[?&]+$/, '');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + W;
  }

  function loadImg(url) {
    return new Promise(function (res, rej) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { res(img); };
      img.onerror = rej;
      img.src = url;
    });
  }

  function analyse(img) {
    var H = Math.round(W * img.naturalHeight / img.naturalWidth);
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, W, H);
    var d = x.getImageData(0, 0, W, H).data, N = W * H, i, X, y;
    var corners = [0, W - 1, (H - 1) * W, N - 1], bg = [0, 0, 0];
    for (i = 0; i < 4; i++) for (var k = 0; k < 3; k++) bg[k] += d[corners[i] * 4 + k] / 4;
    var nb = new Uint8Array(N), dist = new Int32Array(N);
    for (i = 0; i < N; i++) {
      var r = d[i * 4], g = d[i * 4 + 1], b = d[i * 4 + 2];
      nb[i] = (Math.abs(r - bg[0]) + Math.abs(g - bg[1]) + Math.abs(b - bg[2]) >= 60) ? 1 : 0;
      dist[i] = nb[i] ? 1e6 : 0;
    }
    for (y = 0; y < H; y++) for (X = 0; X < W; X++) { i = y * W + X;
      if (X > 0 && dist[i - 1] + 1 < dist[i]) dist[i] = dist[i - 1] + 1;
      if (y > 0 && dist[i - W] + 1 < dist[i]) dist[i] = dist[i - W] + 1; }
    for (y = H - 1; y >= 0; y--) for (X = W - 1; X >= 0; X--) { i = y * W + X;
      if (X < W - 1 && dist[i + 1] + 1 < dist[i]) dist[i] = dist[i + 1] + 1;
      if (y < H - 1 && dist[i + W] + 1 < dist[i]) dist[i] = dist[i + W] + 1; }
    // armação = pixel que não é fundo, perto da borda do objeto (a lente fica "dentro" do aro)
    var fm = new Uint8Array(N), Ls = [];
    for (i = 0; i < N; i++) if (nb[i] && dist[i] >= 5 && dist[i] <= 18) { fm[i] = 1; if (i % 5 === 0) Ls.push(i); }
    if (Ls.length < 30) return null;
    var lum = function (j) { return 0.3 * d[j * 4] + 0.59 * d[j * 4 + 1] + 0.11 * d[j * 4 + 2]; };
    var LL = Ls.map(lum).sort(function (a, b) { return a - b; });
    var med = LL[LL.length >> 1];

    var S = W + 1, sz = S * (H + 1);
    var IF = new Int32Array(sz), IR = new Float64Array(sz), IG = new Float64Array(sz), IB = new Float64Array(sz), IL = new Float64Array(sz), IQ = new Float64Array(sz);
    for (y = 0; y < H; y++) { var a1 = 0, a2 = 0, a3 = 0, a4 = 0, a5 = 0, a6 = 0;
      for (X = 0; X < W; X++) { i = y * W + X; var L = lum(i);
        a1 += fm[i]; a2 += d[i * 4]; a3 += d[i * 4 + 1]; a4 += d[i * 4 + 2]; a5 += L; a6 += L * L;
        var o = (y + 1) * S + X + 1, p = y * S + X + 1;
        IF[o] = IF[p] + a1; IR[o] = IR[p] + a2; IG[o] = IG[p] + a3; IB[o] = IB[p] + a4; IL[o] = IL[p] + a5; IQ[o] = IQ[p] + a6; } }
    function box(A, X, y, s) { return A[(y + s) * S + X + s] - A[y * S + X + s] - A[(y + s) * S + X] + A[y * S + X]; }

    var sizes = [16, 12, 9, 7, 5], cand = [], s;
    for (var si = 0; si < sizes.length && !cand.length; si++) {
      s = sizes[si]; var n = s * s;
      for (y = 0; y + s <= H; y += 2) for (X = 0; X + s <= W; X += 2) {
        if (box(IF, X, y, s) < n) continue;
        var m = box(IL, X, y, s) / n, v = Math.max(0, box(IQ, X, y, s) / n - m * m);
        cand.push({ x: X, y: y, s: s, sc: Math.abs(m - med) + 0.35 * Math.sqrt(v),
          c: [box(IR, X, y, s) / n, box(IG, X, y, s) / n, box(IB, X, y, s) / n], sd: Math.sqrt(v) });
      }
    }
    // tira os recortes com cor de lente (lente de sol é a área grande "funda" dentro do aro)
    var LH = {}, ldn = 0, nbn = 0, kq;
    for (i = 0; i < N; i += 2) if (nb[i]) { nbn++; if (dist[i] >= 22) { kq = (d[i * 4] >> 3) + '_' + (d[i * 4 + 1] >> 3) + '_' + (d[i * 4 + 2] >> 3); LH[kq] = (LH[kq] || 0) + 1; ldn++; } }
    if (ldn < 200 || ldn < nbn * 0.25) ldn = 0; // só existe "lente" quando a área funda é grande (óculos de sol)
    if (ldn > 200) {
      // só filtra quando a faixa perto da borda é quase toda "cor de lente" (aro fino de metal);
      // aro grosso de acetato fica com a cor dele mesmo que a lente seja parecida
      var lim0 = ldn * 0.004, ov = 0;
      for (var u = 0; u < Ls.length; u++) { var jj = Ls[u]; if (LH[(d[jj * 4] >> 3) + '_' + (d[jj * 4 + 1] >> 3) + '_' + (d[jj * 4 + 2] >> 3)] > lim0) ov++; }
      if (ov < Ls.length * 0.5) ldn = 0;
    }
    if (ldn > 200) {
      var lim = ldn * 0.004;
      cand = cand.filter(function (q) { var kk = (q.c[0] >> 3) + '_' + (q.c[1] >> 3) + '_' + (q.c[2] >> 3); return !(LH[kk] > lim); });
    }
    if (!cand.length) {
      // armação fina (metal): sem área cheia para recortar -> amostra metálica com as cores do contorno
      var ring = [];
      for (i = 0; i < N; i++) if (nb[i] && dist[i] >= 1 && dist[i] <= 4) {
        kq = (d[i * 4] >> 3) + '_' + (d[i * 4 + 1] >> 3) + '_' + (d[i * 4 + 2] >> 3);
        if (!(ldn > 200 && LH[kq] > ldn * 0.004)) ring.push(i);
      }
      if (ring.length < 20) return null;
      ring.sort(function (p, q) { return lum(p) - lum(q); });
      var pick = function (f) { var j = ring[Math.min(ring.length - 1, Math.floor(ring.length * f))]; return 'rgb(' + d[j * 4] + ',' + d[j * 4 + 1] + ',' + d[j * 4 + 2] + ')'; };
      var oc = document.createElement('canvas'); oc.width = OUT; oc.height = OUT;
      var gx = oc.getContext('2d'), gr = gx.createLinearGradient(0, 0, OUT, OUT);
      gr.addColorStop(0, pick(0.85)); gr.addColorStop(0.5, pick(0.55)); gr.addColorStop(1, pick(0.25));
      gx.fillStyle = gr; gx.fillRect(0, 0, OUT, OUT);
      return oc.toDataURL('image/jpeg', 0.85);
    }
    cand.sort(function (p, q) { return p.sc - q.sc; });
    var A = cand[0];

    // segunda cor (armação bicolor): precisa ser bem diferente e ocupar boa parte da armação
    var cdist = function (u, w) { return Math.abs(u[0] - w[0]) + Math.abs(u[1] - w[1]) + Math.abs(u[2] - w[2]); };
    var share = function (col) { var h = 0; for (var t = 0; t < Ls.length; t++) { var j = Ls[t]; if (Math.abs(d[j * 4] - col[0]) + Math.abs(d[j * 4 + 1] - col[1]) + Math.abs(d[j * 4 + 2] - col[2]) < 50) h++; } return h / Ls.length; };
    var B = null;
    for (var t = 1; t < cand.length && t < 4000; t++) {
      var cb = cand[t];
      if (cb.sd > 22 || cdist(cb.c, A.c) < 90) continue;
      if (share(cb.c) >= 0.30) { B = cb; break; }
    }

    var o2 = document.createElement('canvas'); o2.width = OUT; o2.height = OUT;
    var ox = o2.getContext('2d'); ox.imageSmoothingQuality = 'high';
    ox.drawImage(c, A.x, A.y, A.s, A.s, 0, 0, OUT, OUT);
    if (B) {
      ox.save(); ox.beginPath(); ox.moveTo(OUT, 0); ox.lineTo(OUT, OUT); ox.lineTo(0, OUT); ox.closePath(); ox.clip();
      ox.drawImage(c, B.x, B.y, B.s, B.s, 0, 0, OUT, OUT); ox.restore();
    }
    return o2.toDataURL('image/jpeg', 0.85);
  }

  function texture(url) {
    var k = keyOf(url);
    if (mem[k]) return Promise.resolve(mem[k]);
    var c = load(k); if (c) { mem[k] = c; return Promise.resolve(c); }
    if (pending[k]) return pending[k];
    var det = url.replace(/-0[15]-(lateral|frente)(\.\w+)/i, '-04-detalhe$2');
    var first = det !== url ? loadImg(sized(det)).then(analyse).catch(function () { return null; }) : Promise.resolve(null);
    pending[k] = first.then(function (r) { return r || loadImg(sized(url)).then(analyse); })
      .then(function (r) { if (r) { mem[k] = r; store(k, r); } delete pending[k]; return r; })
      .catch(function () { delete pending[k]; return null; });
    return pending[k];
  }

  // óculos de sol de metal fino: a foto quase não mostra o aro, então usa o tom metálico do nome da cor
  var METAL = [[/^dourad/i, ['#F3DDA0', '#C9A45C', '#9C7A3A']], [/^prat/i, ['#F1F2F4', '#B4B8BE', '#878C93']], [/^ros[eé]/i, ['#F2D3C8', '#C99A8B', '#9E6E62']]];
  function metal(label, url) {
    if (/-0[145]-(lateral|frente|detalhe)/i.test(url)) return null; // fotos de armação de grau/clip-on: recorte real
    var inp = document.getElementById(label.getAttribute('for'));
    var v = ((inp && inp.value) || label.textContent || '').trim();
    if (/ com | e /i.test(v)) return null;
    for (var i = 0; i < METAL.length; i++) if (METAL[i][0].test(v)) {
      var k = 'metal:' + i;
      if (mem[k]) return mem[k];
      var oc = document.createElement('canvas'); oc.width = OUT; oc.height = OUT;
      var gx = oc.getContext('2d'), gr = gx.createLinearGradient(0, 0, OUT, OUT), cs = METAL[i][1];
      gr.addColorStop(0, cs[1]); gr.addColorStop(0.45, cs[0]); gr.addColorStop(1, cs[2]);
      gx.fillStyle = gr; gx.fillRect(0, 0, OUT, OUT);
      return (mem[k] = oc.toDataURL('image/jpeg', 0.9));
    }
    return null;
  }

  function apply(label) {
    var url = srcOf(label);
    if (!url) return;
    label.setAttribute('data-ytex-src', url);
    var mt = metal(label, url);
    (mt ? Promise.resolve(mt) : texture(url)).then(function (r) {
      if (label.getAttribute('data-ytex-src') !== url) return;
      if (!r) { label.setAttribute('data-ytex', '0'); return; }
      label.style.setProperty('background-image', 'url(' + r + ')', 'important');
      label.style.setProperty('background-size', 'cover', 'important');
      label.style.setProperty('background-position', 'center', 'important');
      label.setAttribute('data-ytex', '1');
    });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); apply(e.target); } });
  }, { rootMargin: '300px' }) : null;

  function scan(root) {
    (root || document).querySelectorAll(SEL).forEach(function (l) {
      var url = srcOf(l);
      if (!url) return; // já é textura (data:) ou cor sólida
      if (l.getAttribute('data-ytex-src') === url && l.getAttribute('data-ytex') !== '1') return; // falhou ou em andamento
      var k = keyOf(url);
      if (mem[k] || load(k) || !io) apply(l); else io.observe(l);
    });
  }

  // enquanto a textura não fica pronta, não mostra a foto do óculos inteiro na amostra
  var st = document.createElement('style');
  st.textContent = 'label.swatch-anchor[style*="url("]:not([style*="data:"]):not([data-ytex]){background-image:none!important;background-color:#ece9e4!important}';
  document.head.appendChild(st);

  var t;
  new MutationObserver(function () { if (t) return; t = setTimeout(function () { t = null; scan(); }, 120); })
    .observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['style'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
})();
